"use client";

const Button = ({ type = "normal", onClick, children, className }) => {
  return (
    <button className={`button ${type} ${className}`} onClick={onClick}>
      {children}
    </button>
  );
};

export { Button };
